import { Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getProfile } from "@/api/profile";
import { useAuthStore } from "@/stores/auth";

/**
 * Client-side guard for /admin/*. Backend enforces require_admin on
 * every endpoint, so this is a UX nicety — if a non-admin hits an
 * admin URL directly we bounce them to Dashboard instead of letting
 * them see a page full of 403s.
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.token);
  const profileQ = useQuery({
    queryKey: ["profile"],
    queryFn: getProfile,
    enabled: !!token,
  });

  if (!token) return <Navigate to="/login" replace />;
  if (profileQ.isLoading) {
    return <div className="py-10 text-center text-taupe">…</div>;
  }
  if (!profileQ.data?.is_admin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
